import { STATS } from '@/lib/content';
import './Stats.css';

export function Stats() {
  return (
    <section className="section section--alt" id="who-its-for">
      <div className="container">
        <div className="section__head">
          <span className="overline">Who this is for</span>
          <h2>63 million people are doing this job without any tools</h2>
          <p className="lead">
            The caregiving population in the United States grew 45% in a decade. The average caregiver
            puts in 27 hours a week — nearly a quarter give 40 or more. And the share reporting real
            difficulty coordinating care has climbed from 19% to 26%, because the systems never adapted
            to the fact that a family member is now the integration layer.
          </p>
        </div>

        {/* Stat tiles, not a chart: four unrelated magnitudes with different
            units don't share an axis, so plotting them together would imply a
            comparison that isn't there. */}
        <dl className="stats">
          {STATS.map((stat) => (
            <div className="stats__item" key={stat.value}>
              <dt className="stats__num">{stat.value}</dt>
              <dd className="stats__label">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
